import { createGetPropGetter } from '@/store/utils';

export default {
  spWorkerServicesChosen: createGetPropGetter('spWorkerServicesChosen', []),
  spWorkerCertificationsChosen: createGetPropGetter('spWorkerCertificationsChosen', []),
  spWorkerGeneralInfo: createGetPropGetter('spWorkerGeneralInfo', {}),
  spWorkerAvatar: createGetPropGetter('spWorkerAvatar', null),
};
